/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import moment from 'moment';
import {Row, Col, Box, Button, Pagination} from 'adminlte-2-react';
import Loader from '../utils/Loader';
import {Alert} from '../ui/alert';
import {
  getDateOrEmpty,
  getDateUtc,
  getDateUtcOrEmpty,
  toTitleCase,
} from '../utils/utils';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Content} from '../ui/Content';
import {useWindowSize} from '../utils/useWindowSize';
import {DateRangeInput} from '../ui/DateRangeInput';
import {SelectInput} from '../utils/SelectInput';
import {SelectSelectores} from './SelectSelectores';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {CustomBox} from '../ui/layout/CustomBox';
import {ModalGenerico} from '../ui/ModalGenerico';

export const ReportesEnviadosListView = ({
  history,
  topAlert,
  submitAlert,
  totalResults,
  page,
  pageSize,
  handlePage,
  lista,
  reportesEnviadosGet,
  fechaInicio,
  setFechaInicio,
  fechaFin,
  setFechaFin,
  tipoOption,
  setTipoOption,
  tipoOptions,
  selectorId,
  token,
  setSelectorId,
  sumatoria,
  isModalShown,
  setIsModalShown,
  enviarReporte,
  enviarReporteModel,
}) => {
  const {isMobile} = useWindowSize();

  return (
    <Content title="Reportes Enviados" history={history}>
      {isModalShown && (
        <ModalGenerico
          isModalShown={isModalShown}
          hideModal={() => setIsModalShown(false)}
          title="Confirmar"
          body="Se enviará manualmente el reporte de hoy. Esta acción no se puede deshacer. ¿Continuar?"
          buttonText="Continuar"
          submit={enviarReporte}
          buttonLoading={enviarReporteModel.loading}
        />
      )}

      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      <Row>
        <Col md="10" mdOffset="1">
          <CustomBox
            title="Filtro"
            customOptions={
              <ButtonWithLoading
                type="success"
                size="sm"
                text="Enviar reporte diario"
                submit={() => setIsModalShown(true)}
              />
            }>
            <Col xs="12" md="6">
              <div className="form-group">
                <label>Fecha</label>

                <DateRangeInput
                  showLabels
                  labelStyle={{fontWeight: 'normal'}}
                  inicio={fechaInicio}
                  setInicio={setFechaInicio}
                  fin={fechaFin}
                  setFin={setFechaFin}
                  xs={12}
                  md={6}
                />
              </div>
            </Col>

            <Col md="3">
              <br />
              <SelectInput
                label="Tipo"
                value={tipoOption}
                options={tipoOptions}
                setValue={setTipoOption}
              />
            </Col>

            {token?.decoded?.rol === 'admin' && (
              <Col md="3">
                <br />
                <SelectSelectores
                  selectorId={selectorId}
                  token={token}
                  onSelect={setSelectorId}
                />
              </Col>
            )}

            <Col md="12">
              <div style={{float: 'right'}}>
                <div style={{display: 'inline-block', marginRight: 10}}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(1)}
                  />
                </div>
              </div>
            </Col>
          </CustomBox>
        </Col>
        <Col md="10" mdOffset="1">
          <Box title="Lista">
            <div style={{display: 'block'}}>
              <span>Total: {totalResults}</span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: 'space-between',
              }}>
              <div>
                <Pagination
                  activePage={page - 1}
                  pageSize={pageSize}
                  totalElements={totalResults}
                  onChange={page => handlePage(page + 1)}
                  labels={{
                    first: 'Primera',
                    last: 'Última',
                    previous: 'Anterior',
                    next: 'Siguiente',
                  }}
                />
              </div>
            </div>

            <Loader isLoading={reportesEnviadosGet.loading}>
              {lista && lista.length > 0 ? (
                <Box noPadding={true} border={false} style={{borderTop: 0}}>
                  <div className="table-responsive">
                    <DataTable
                      lazy
                      pt={{
                        table: {
                          className: 'table table-hover',
                        },
                      }}
                      value={lista}
                      emptyMessage="No se encontraron registros">
                      <Column field="selectorNombre" header="Nombre" />

                      <Column
                        field="tipo"
                        header="Tipo"
                        body={reporte => (
                          <>
                            <b>{toTitleCase(reporte.frecuencia)}</b>
                            <br />
                            Desde: {getDateUtc(reporte.fechaInicio)}
                            <br />
                            Hasta: {getDateUtc(reporte.fechaFin)}
                          </>
                        )}
                      />

                      <Column
                        field="datos.llamadas"
                        header="Filtros"
                        style={{width: '10%'}}
                      />

                      <Column
                        field="datos.citados"
                        header="Citados"
                        style={{width: '10%'}}
                        body={reporte => reporte?.datos?.citados || 0}
                      />
                      <Column
                        field="datos.entrevistas"
                        header="Entrevistas"
                        style={{width: '10%'}}
                      />
                      <Column
                        field="datos.procesados"
                        header="Procesados"
                        style={{width: '10%'}}
                      />
                      <Column
                        field="datos.cierres"
                        header="Cierres"
                        style={{width: '10%'}}
                      />
                      <Column
                        header="Reporte"
                        body={reporte => {
                          const enlace = `/produccion/selector/?selectorId=${
                            reporte.selectorIdNumerico
                          }&fechaFin=${getDateUtcOrEmpty(
                            reporte.fechaFin,
                          )}&fechaInicio=${getDateUtcOrEmpty(
                            reporte.fechaInicio,
                          )}&tipo=selectorYSupervisor`;
                          return (
                            <>
                              <a
                                className="btn btn-sm btn-primary"
                                href={enlace}
                                onClick={e => {
                                  e.preventDefault();
                                  history.push(enlace);
                                }}>
                                Ver
                              </a>
                            </>
                          );
                        }}
                      />
                    </DataTable>
                  </div>
                </Box>
              ) : (
                <h4>No se han encontrado reportes</h4>
              )}
            </Loader>
            <Pagination
              activePage={page - 1}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={page => handlePage(page + 1)}
              labels={{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}
            />
            <Row>
              <Col sm="2">
                <span>Total: {totalResults}</span>
              </Col>
              <Col sm="2">
                <span>Citados: {sumatoria?.[0]?.totalCitados}</span>
              </Col>
              <Col sm="2">
                <span>Filtros: {sumatoria?.[0]?.totalLlamadas}</span>
              </Col>
              <Col sm="2">
                <span>Entrevistas: {sumatoria?.[0]?.totalEntrevistas}</span>
              </Col>
              <Col sm="2">
                <span>Procesados: {sumatoria?.[0]?.totalProcesados}</span>
              </Col>
              <Col sm="2">
                <span>Cierres: {sumatoria?.[0]?.totalCierres}</span>
              </Col>
            </Row>

            {submitAlert.text && (
              <Alert
                title={submitAlert.title}
                type={submitAlert.type}
                text={submitAlert.text}
                closable={submitAlert.closable}
              />
            )}
          </Box>
        </Col>
      </Row>
    </Content>
  );
};
